export const products = [
  // ── DRESSES ──────────────────────────────────────────────────
  {
    id: 1,
    name: "Celeste Floral Midi Dress",
    price: 345,
    category: "Dresses",
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["Ivory Floral", "Sage Floral"],
    description: "A dreamy midi cut in cotton voile with an all-over botanical print. Smocked bodice, flutter sleeves, and a gently flared skirt that moves beautifully in the breeze.",
    images: [
      "https://images.unsplash.com/photo-1572804013427-4d7ca7268217?w=800&q=80",
      "https://images.unsplash.com/photo-1596783074918-c84cb06531ca?w=800&q=80"
    ],
    badge: "Bestseller",
    featured: true
  },
  {
    id: 2,
    name: "Margot Ruffle Maxi Dress",
    price: 395,
    category: "Dresses",
    sizes: ["XS", "S", "M", "L"],
    colors: ["Dusty Rose", "Cream"],
    description: "Floor-length elegance in silk-blend charmeuse. Bias cut with cascading ruffle trim at the hem and a delicate v-neckline. The kind of dress you wear to remember.",
    images: [
      "https://images.unsplash.com/photo-1566479179817-c0cd9e0e1a87?w=800&q=80",
      "https://images.unsplash.com/photo-1515372039744-b8f02a3ae446?w=800&q=80"
    ],
    badge: "New Arrival",
    featured: true
  },
  {
    id: 3,
    name: "Isla Smocked Midi Dress",
    price: 285,
    category: "Dresses",
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["Terracotta", "Navy Stripe"],
    description: "Relaxed and romantic in organic cotton with an elasticated smocked bodice. Short puff sleeves, a tiered skirt with gentle volume — effortless for every season.",
    images: [
      "https://images.unsplash.com/photo-1496747611176-843222e1e57c?w=800&q=80",
      "https://images.unsplash.com/photo-1583744946564-b52ac1c389c8?w=800&q=80"
    ],
    featured: true
  },
  {
    id: 4,
    name: "Solene Linen Shirt Dress",
    price: 265,
    category: "Dresses",
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["Ecru", "Pale Blue", "Black"],
    description: "A crisp, button-front shirt dress in washed linen. Slightly oversized with a belted waist, breast pockets, and a relaxed midi hem. Transitions effortlessly from morning to evening.",
    images: [
      "https://images.unsplash.com/photo-1551803091-e20673f15770?w=800&q=80",
      "https://images.unsplash.com/photo-1595777457583-95e059d581b8?w=800&q=80"
    ]
  },
  {
    id: 5,
    name: "Violette Silk Slip Dress",
    price: 310,
    category: "Dresses",
    sizes: ["XS", "S", "M", "L"],
    colors: ["Champagne", "Midnight"],
    description: "Poured in heavy charmeuse silk, this bias-cut slip dress moves with the body in the way only silk can. Delicate adjustable straps and a subtle cowl neck.",
    images: [
      "https://images.unsplash.com/photo-1612336307429-8a898d10e223?w=800&q=80",
      "https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=800&q=80"
    ],
    badge: "Limited"
  },
  {
    id: 6,
    name: "Beatrice Broderie Maxi",
    price: 420,
    category: "Dresses",
    sizes: ["XS", "S", "M", "L"],
    colors: ["White", "Blush"],
    description: "Sweeping cotton broderie anglaise in a full-length silhouette. Tiered skirt, square neckline, and delicate eyelet embroidery throughout.",
    images: [
      "https://images.unsplash.com/photo-1585386959984-a4155224a1ad?w=800&q=80",
      "https://images.unsplash.com/photo-1564257631407-4deb1f99d992?w=800&q=80"
    ],
    badge: "New Arrival"
  },
  {
    id: 7,
    name: "Orla Mini Floral Dress",
    price: 245,
    category: "Dresses",
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["Meadow Print", "Lilac Print"],
    description: "A playful mini in lightweight cotton poplin with an all-over floral print. Balloon sleeves, a smocked back, and a flirty A-line skirt.",
    images: [
      "https://images.unsplash.com/photo-1509631179647-0177331693ae?w=800&q=80",
      "https://images.unsplash.com/photo-1475180098004-ca77a66827be?w=800&q=80"
    ]
  },
  // ── TOPS ─────────────────────────────────────────────────────
  {
    id: 8,
    name: "Romilly Lace Blouse",
    price: 185,
    category: "Tops",
    sizes: ["XS", "S", "M", "L"],
    colors: ["Ivory", "Black"],
    description: "Delicate Chantilly lace on a structured cotton foundation. Slightly cropped with a soft collar and pearlescent buttons down the front.",
    images: [
      "https://images.unsplash.com/photo-1564584217132-2271feaeb3c5?w=800&q=80",
      "https://images.unsplash.com/photo-1485968579580-b6d095142e6e?w=800&q=80"
    ],
    badge: "Bestseller",
    featured: true
  },
  {
    id: 9,
    name: "Daphne Smocked Crop Top",
    price: 135,
    category: "Tops",
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["White", "Sage", "Terracotta"],
    description: "A light cotton voile crop top with an elasticated smocked bodice and adjustable tie straps. The perfect top for layering or wearing alone.",
    images: [
      "https://images.unsplash.com/photo-1503342217505-b0a15ec3261c?w=800&q=80",
      "https://images.unsplash.com/photo-1434389677669-e08b4cac3105?w=800&q=80"
    ]
  },
  {
    id: 10,
    name: "Henley Linen Blouse",
    price: 155,
    category: "Tops",
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["Ecru", "Soft Lavender", "Clay"],
    description: "Relaxed washed linen with a classic Henley neckline, button placket, and slightly oversized fit. Tuck into high-waisted trousers or let it fall loose.",
    images: [
      "https://images.unsplash.com/photo-1529139574466-a303027614ff?w=800&q=80",
      "https://images.unsplash.com/photo-1503342217505-b0a15ec3261c?w=800&q=80"
    ]
  },
  {
    id: 11,
    name: "Fiona Puff Sleeve Blouse",
    price: 165,
    category: "Tops",
    sizes: ["XS", "S", "M", "L"],
    colors: ["Ivory", "Cornflower Blue"],
    description: "A romantic blouse in cotton poplin with voluminous puff sleeves that cinch elegantly at the wrist. Gathered at the bodice with a subtle tuck-in hem.",
    images: [
      "https://images.unsplash.com/photo-1548624313-0396c75e4b1a?w=800&q=80",
      "https://images.unsplash.com/photo-1485462537746-965f33f7f6a7?w=800&q=80"
    ],
    badge: "New Arrival"
  },
  {
    id: 12,
    name: "Clara Wrap Camisole",
    price: 98,
    category: "Tops",
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["Champagne Silk", "Black Silk", "Dusty Pink"],
    description: "A fluid satin camisole with adjustable wrap ties and a plunging v-neckline. Wear it tucked into jeans or as a delicate layering piece under a blazer.",
    images: [
      "https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=800&q=80",
      "https://images.unsplash.com/photo-1594223274512-ad4803739b7c?w=800&q=80"
    ]
  },
  // ── SKIRTS ───────────────────────────────────────────────────
  {
    id: 13,
    name: "Aurore Floral Midi Skirt",
    price: 195,
    category: "Skirts",
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["Garden Print", "Dark Floral"],
    description: "A full midi skirt in liberty-print cotton with a smocked elasticated waist and a graceful tiered hem. Pairs beautifully with a simple camisole.",
    images: [
      "https://images.unsplash.com/photo-1583496661160-fb5886a0aaaa?w=800&q=80",
      "https://images.unsplash.com/photo-1542219550-37153d387c27?w=800&q=80"
    ],
    featured: true
  },
  {
    id: 14,
    name: "Elodie Wrap Linen Skirt",
    price: 165,
    category: "Skirts",
    sizes: ["XS", "S", "M", "L"],
    colors: ["Sand", "Olive", "White"],
    description: "A classic wrap skirt in washed linen with a side tie and a fluid midi length. A wardrobe essential that takes you from beach to dinner.",
    images: [
      "https://images.unsplash.com/photo-1577900232427-18219b9166a0?w=800&q=80",
      "https://images.unsplash.com/photo-1506629082955-511b1aa562c8?w=800&q=80"
    ]
  },
  {
    id: 15,
    name: "Marguerite Broderie Skirt",
    price: 215,
    category: "Skirts",
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["White", "Ecru"],
    description: "A voluminous tiered maxi skirt in broderie anglaise cotton with intricate eyelet embroidery throughout. The kind of skirt that becomes a summer signature.",
    images: [
      "https://images.unsplash.com/photo-1601924638867-3a6de6b7a500?w=800&q=80",
      "https://images.unsplash.com/photo-1471107340929-a87cd0f5b5f3?w=800&q=80"
    ],
    badge: "Bestseller"
  },
  // ── TROUSERS & DENIM ──────────────────────────────────────────
  {
    id: 16,
    name: "Paloma Wide-Leg Trousers",
    price: 225,
    category: "Trousers",
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["Ecru", "Black", "Sage"],
    description: "Fluid wide-leg trousers in a lightweight linen-viscose blend. High-waisted with a gentle pleat front and a sweeping leg that elongates the silhouette.",
    images: [
      "https://images.unsplash.com/photo-1594938298603-c8148c4b4f5a?w=800&q=80",
      "https://images.unsplash.com/photo-1475180098004-ca77a66827be?w=800&q=80"
    ],
    featured: true
  },
  {
    id: 17,
    name: "Vivienne Straight-Leg Jeans",
    price: 195,
    category: "Denim",
    sizes: ["24", "25", "26", "27", "28", "29", "30", "31"],
    colors: ["Vintage Indigo", "Light Wash", "Black"],
    description: "A high-rise straight-leg cut in 100% organic cotton denim. Medium-weight with a slight stretch for comfort — the perfect everyday jean that improves with every wash.",
    images: [
      "https://images.unsplash.com/photo-1541099649105-f69ad21f3246?w=800&q=80",
      "https://images.unsplash.com/photo-1565084888279-aca607bb7795?w=800&q=80"
    ],
    badge: "Bestseller"
  },
  {
    id: 18,
    name: "Stella Barrel-Leg Jeans",
    price: 210,
    category: "Denim",
    sizes: ["24", "25", "26", "27", "28", "29", "30"],
    colors: ["Washed Blue", "Ecru"],
    description: "The barrel leg: wide at the thigh, tapered at the ankle, cinched at a high waist. In a soft, broken-in cotton denim that feels lived-in from day one.",
    images: [
      "https://images.unsplash.com/photo-1507680434567-5739c80be1ac?w=800&q=80",
      "https://images.unsplash.com/photo-1582552938357-32b906df40cb?w=800&q=80"
    ],
    badge: "New Arrival"
  },
  // ── KNITWEAR ──────────────────────────────────────────────────
  {
    id: 19,
    name: "Corinne Cashmere Cardigan",
    price: 385,
    category: "Knitwear",
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["Camel", "Ivory", "Slate Blue"],
    description: "A generous, open-front cardigan in Grade A Mongolian cashmere. Two front pockets, a relaxed boxy fit, and the kind of softness that makes you want to wear nothing else.",
    images: [
      "https://images.unsplash.com/photo-1434389677669-e08b4cac3105?w=800&q=80",
      "https://images.unsplash.com/photo-1485462537746-965f33f7f6a7?w=800&q=80"
    ],
    badge: "Bestseller",
    featured: true
  },
  {
    id: 20,
    name: "Eloise Ribbed Knit Sweater",
    price: 245,
    category: "Knitwear",
    sizes: ["XS", "S", "M", "L"],
    colors: ["Oat", "Dusty Rose", "Forest Green"],
    description: "A classic crew-neck sweater in a thick, luxurious ribbed knit. Relaxed and oversized with dropped shoulders — effortless weekend dressing.",
    images: [
      "https://images.unsplash.com/photo-1576566588028-4147f3842f27?w=800&q=80",
      "https://images.unsplash.com/photo-1520367445093-50dc08a59d9d?w=800&q=80"
    ]
  },
  {
    id: 21,
    name: "Beatrix Wool Turtleneck",
    price: 195,
    category: "Knitwear",
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["Charcoal", "Cream", "Burgundy"],
    description: "A fine-gauge merino wool turtleneck with a slim, body-skimming fit. Incredibly soft — the perfect layering piece or standalone statement.",
    images: [
      "https://images.unsplash.com/photo-1604644401890-0bd678c83788?w=800&q=80",
      "https://images.unsplash.com/photo-1591047139829-d91aecb6caea?w=800&q=80"
    ]
  },
  // ── OUTERWEAR ─────────────────────────────────────────────────
  {
    id: 22,
    name: "Claudette Trench Coat",
    price: 545,
    category: "Outerwear",
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["Honey", "Chalk"],
    description: "A heritage trench in water-resistant cotton gabardine. Double-breasted with epaulettes, storm flap, and a belted waist. An eternal classic, cut for the modern woman.",
    images: [
      "https://images.unsplash.com/photo-1539109136881-3be0616acf4b?w=800&q=80",
      "https://images.unsplash.com/photo-1548624313-0396c75e4b1a?w=800&q=80"
    ],
    featured: true
  },
  {
    id: 23,
    name: "Helena Cashmere Overcoat",
    price: 795,
    category: "Outerwear",
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["Camel", "Black", "Stone"],
    description: "Heritage-weight pure cashmere in a generous, enveloping silhouette. Single-breasted with a notched lapel and a clean, uncluttered form. Buy it once. Wear it for life.",
    images: [
      "https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=800&q=80",
      "https://images.unsplash.com/photo-1539109136881-3be0616acf4b?w=800&q=80"
    ],
    badge: "Limited"
  },
  {
    id: 24,
    name: "Josephine Velvet Blazer",
    price: 425,
    category: "Outerwear",
    sizes: ["XS", "S", "M", "L"],
    colors: ["Midnight Navy", "Forest Green", "Burgundy"],
    description: "A sculptural single-breasted blazer in crushed velvet. Slightly oversized with padded shoulders and a single button closure. Wear it over everything.",
    images: [
      "https://images.unsplash.com/photo-1594938298603-c8148c4b4f5a?w=800&q=80",
      "https://images.unsplash.com/photo-1583744946564-b52ac1c389c8?w=800&q=80"
    ],
    badge: "New Arrival"
  },
  // ── SWIMWEAR ──────────────────────────────────────────────────
  {
    id: 25,
    name: "Ines Floral Bikini Set",
    price: 185,
    category: "Swimwear",
    sizes: ["XS", "S", "M", "L"],
    colors: ["Garden Print", "Midnight Floral"],
    description: "A delicate floral bikini in Italian stretch fabric. Triangle top with adjustable ties and matching high-cut briefs. Lined for comfort, designed to last seasons.",
    images: [
      "https://images.unsplash.com/photo-1570976447640-ac859082b065?w=800&q=80",
      "https://images.unsplash.com/photo-1582452932542-6e479a0e91e5?w=800&q=80"
    ],
    badge: "New Arrival"
  },
  {
    id: 26,
    name: "Marina One-Piece Swimsuit",
    price: 225,
    category: "Swimwear",
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["Black", "Terracotta", "Ivory"],
    description: "A classic one-piece in Italian maillot fabric with a plunging v-neckline, adjustable straps, and a beautifully cut low back. Sophisticated poolside dressing.",
    images: [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80",
      "https://images.unsplash.com/photo-1570976447640-ac859082b065?w=800&q=80"
    ]
  },
  {
    id: 27,
    name: "Coco Broderie Cover-Up",
    price: 155,
    category: "Swimwear",
    sizes: ["XS/S", "M/L"],
    colors: ["White", "Ecru"],
    description: "A breezy cover-up in broderie anglaise cotton. Long sleeves, an open back with tie detail, and a midi hem. Beautiful layered over swimwear or worn as a beach dress.",
    images: [
      "https://images.unsplash.com/photo-1574180566232-aaad1b5b8450?w=800&q=80",
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&q=80"
    ]
  },
  // ── SHOES ────────────────────────────────────────────────────
  {
    id: 28,
    name: "Colette Leather Mules",
    price: 275,
    category: "Shoes",
    sizes: ["36", "37", "38", "39", "40", "41"],
    colors: ["Tan", "Black", "White"],
    description: "A square-toe slide mule in vegetable-tanned leather with a stacked wooden heel. Minimal, architectural, and genuinely comfortable for all-day wear.",
    images: [
      "https://images.unsplash.com/photo-1543163521-1bf539c55dd2?w=800&q=80",
      "https://images.unsplash.com/photo-1518049362265-d5b2a6467637?w=800&q=80"
    ],
    badge: "Bestseller"
  },
  {
    id: 29,
    name: "Paloma Leather Sandals",
    price: 195,
    category: "Shoes",
    sizes: ["36", "37", "38", "39", "40", "41"],
    colors: ["Cognac", "Black", "Tan"],
    description: "Flat leather sandals with a woven strap detail and a cushioned footbed. Hand-stitched in Mallorca from full-grain leather — a summer essential for decades.",
    images: [
      "https://images.unsplash.com/photo-1603487742131-4160ec999306?w=800&q=80",
      "https://images.unsplash.com/photo-1543163521-1bf539c55dd2?w=800&q=80"
    ]
  },
  {
    id: 30,
    name: "Sienna Western Boots",
    price: 445,
    category: "Shoes",
    sizes: ["36", "37", "38", "39", "40", "41"],
    colors: ["Honey Suede", "Black Leather"],
    description: "A refined take on the western boot in full-grain leather with tonal stitching and a stacked heel. The kind of boots you wear until perfectly broken in.",
    images: [
      "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=800&q=80",
      "https://images.unsplash.com/photo-1608256246200-53e635b5b65f?w=800&q=80"
    ],
    badge: "New Arrival",
    featured: true
  },
  // ── BAGS ─────────────────────────────────────────────────────
  {
    id: 31,
    name: "Rosalie Raffia Tote",
    price: 195,
    category: "Bags",
    sizes: ["One Size"],
    colors: ["Natural", "Black"],
    description: "A generously sized tote handwoven from natural raffia by artisans in Madagascar. Leather handles, an internal cotton lining, and a magnetic snap closure.",
    images: [
      "https://images.unsplash.com/photo-1548036328-c9fa89d128fa?w=800&q=80",
      "https://images.unsplash.com/photo-1566150905458-1bf1fc113f0d?w=800&q=80"
    ],
    badge: "Bestseller"
  },
  {
    id: 32,
    name: "Elise Mini Leather Bag",
    price: 355,
    category: "Bags",
    sizes: ["One Size"],
    colors: ["Cognac", "Black", "Cream"],
    description: "A structured mini handbag in pebbled Italian leather. Top handle with optional crossbody strap, suede interior, and a polished gold-tone clasp.",
    images: [
      "https://images.unsplash.com/photo-1584917865442-de89df76afd3?w=800&q=80",
      "https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=800&q=80"
    ]
  },
  {
    id: 33,
    name: "Lucia Woven Clutch",
    price: 145,
    category: "Bags",
    sizes: ["One Size"],
    colors: ["Natural Straw", "Black Straw"],
    description: "An evening clutch hand-woven from sea grass with a satin lining and a simple kiss-lock clasp. Small but perfectly considered.",
    images: [
      "https://images.unsplash.com/photo-1566150905458-1bf1fc113f0d?w=800&q=80",
      "https://images.unsplash.com/photo-1548036328-c9fa89d128fa?w=800&q=80"
    ]
  },
  // ── ACCESSORIES ──────────────────────────────────────────────
  {
    id: 34,
    name: "Florentine Silk Scarf",
    price: 115,
    category: "Accessories",
    sizes: ["One Size"],
    colors: ["Ivory Print", "Dusty Rose Print", "Sage Print"],
    description: "A large-format silk twill scarf with an original hand-painted botanical print. Wear it in your hair, around the neck, or draped over the shoulders.",
    images: [
      "https://images.unsplash.com/photo-1601924638867-3a6de6b7a500?w=800&q=80",
      "https://images.unsplash.com/photo-1617137984095-74e4e5e3613f?w=800&q=80"
    ],
    badge: "New Arrival"
  },
  {
    id: 35,
    name: "Soleil Straw Hat",
    price: 95,
    category: "Accessories",
    sizes: ["S/M", "L/XL"],
    colors: ["Natural", "Black Band"],
    description: "A classic wide-brim hat handwoven from Ecuadorian toquilla straw. Lightweight and packable with a grosgrain ribbon band. Summer's most important accessory.",
    images: [
      "https://images.unsplash.com/photo-1521369909029-2afed882baee?w=800&q=80",
      "https://images.unsplash.com/photo-1572307480813-ceb0e59d8325?w=800&q=80"
    ]
  },
  {
    id: 36,
    name: "Margot Tortoise Sunglasses",
    price: 145,
    category: "Accessories",
    sizes: ["One Size"],
    colors: ["Honey Tortoise", "Black", "Clear Amber"],
    description: "Cat-eye acetate frames in rich tortoiseshell with polarised UV400 lenses. Hand-crafted in Italy — designed to flatter and to last.",
    images: [
      "https://images.unsplash.com/photo-1577803645773-f96470509666?w=800&q=80",
      "https://images.unsplash.com/photo-1574258495973-f010dfbb5371?w=800&q=80"
    ]
  },
  // ── JEWELLERY ────────────────────────────────────────────────
  {
    id: 37,
    name: "Pearl Drop Earrings",
    price: 125,
    category: "Jewellery",
    sizes: ["One Size"],
    colors: ["Gold/Pearl", "Silver/Pearl"],
    description: "Freshwater baroque pearls suspended from a delicate gold-vermeil or silver drop. Each pearl is unique in its lustre and shape — wearable sculpture.",
    images: [
      "https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?w=800&q=80",
      "https://images.unsplash.com/photo-1611591437281-460bfbe1220a?w=800&q=80"
    ],
    badge: "Bestseller",
    featured: true
  },
  {
    id: 38,
    name: "Twisted Gold Ring",
    price: 95,
    category: "Jewellery",
    sizes: ["5", "6", "7", "8"],
    colors: ["14k Gold-Fill", "Sterling Silver"],
    description: "A sculptural twisted band in 14k gold-fill or sterling silver. Stack it, wear it alone, or mix metals — endlessly wearable.",
    images: [
      "https://images.unsplash.com/photo-1605100804763-247f67b3557e?w=800&q=80",
      "https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=800&q=80"
    ]
  },
  {
    id: 39,
    name: "Layered Gold Necklace",
    price: 165,
    category: "Jewellery",
    sizes: ["One Size"],
    colors: ["14k Gold-Fill", "Sterling Silver"],
    description: "Three delicate chains of varying lengths designed to be worn together. A 16\", 18\", and 20\" layer in 14k gold-fill. Effortless and eternal.",
    images: [
      "https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?w=800&q=80",
      "https://images.unsplash.com/photo-1611591437281-460bfbe1220a?w=800&q=80"
    ]
  },
  // ── LOUNGEWEAR ───────────────────────────────────────────────
  {
    id: 40,
    name: "Sophie Linen Pyjama Set",
    price: 215,
    category: "Loungewear",
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["White Stripe", "Pale Blue", "Ecru"],
    description: "A matching shirt and trouser set in washed Italian linen. The kind of pyjamas so beautiful you'll wear them far beyond the bedroom.",
    images: [
      "https://images.unsplash.com/photo-1571945153237-4929e783af4a?w=800&q=80",
      "https://images.unsplash.com/photo-1576566588028-4147f3842f27?w=800&q=80"
    ]
  },
  {
    id: 41,
    name: "Celeste Ribbed Lounge Set",
    price: 175,
    category: "Loungewear",
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: ["Oatmeal", "Dusty Pink", "Sage"],
    description: "A matching crop tank and wide-leg trouser in thick ribbed cotton. Incredibly soft, beautifully cut — luxurious comfort without compromising style.",
    images: [
      "https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=800&q=80",
      "https://images.unsplash.com/photo-1594223274512-ad4803739b7c?w=800&q=80"
    ],
    badge: "New Arrival"
  },
];

export const categories = [
  "All", "Dresses", "Tops", "Skirts", "Trousers", "Denim",
  "Knitwear", "Outerwear", "Swimwear", "Shoes", "Bags",
  "Accessories", "Jewellery", "Loungewear"
];
